import { useMutation } from "react-query";

import { api } from "../util/api";

import { IApiResponse } from "./IApiResponse";

type IChangePassword = Record<string, string>;

export function useChangePassword() {
  return useMutation<
    IApiResponse<IChangePassword>,
    IApiResponse<IChangePassword>,
    IChangePassword
  >("change-password", async (data: IChangePassword) => {
    const response = await api.post<IApiResponse<IChangePassword>>(
      "/users/change-password",
      data
    );

    if (response.status !== 201) {
      throw response.data;
    }

    return response.data;
  });
}
